import { Observable } from 'rxjs';
import { DatosPersonalesRequest } from 'src/app/global/interfaces/datos-personales-request';

export abstract class DatosPersonalesService {

  abstract obtenerDatosPersonales(rut: number): Observable<any>;
  abstract obtenerNacionalidades(): Observable<any>;
  abstract registraDatosPersonales(datosPersonales: DatosPersonalesRequest): Observable<any>;
  abstract validaEdicion(): Observable<any>;
}
